// this file is generated by update_shopify_store_data.py at 2026-01-26 20:20:29.298835
var courses = [
    {
        "course_id": "F82B4AC9-E913-F011-999F-005056A77B46",
        "course_version": 1,
        "name": "Behavioral and Mental Health Concerns in Patients with Intellectual and Developmental Disabilities (IDD)",
        "course_type": 1,
        "author_information": "Dr. Holly Brown, DNP, RN, PMHNP-BC, PMHCS; \r\nDr. Janeice DeSocio, Ph.D., RN, PMHNP-BC, FAAN;\r\nDr. Shirley McMillan Ph.D., RN, CDDN;\r\nDr. Deborah Napolitano, Ph.D., BCBA-D, LBA",
        "description": "In this module we will explore the reasons behind some behaviors of concern you may see in the hospital setting when working with individuals with intellectual and developmental disabilities, how to assess them, and how to respond.",
        "learning_objectives_html": "By the time you complete this course, you will be able to:\r\n<ul>\r\n    <li>Analyze causes of behaviors of concern in hospitalized patients with intellectual and developmental disabilities (IDD)</li>\r\n    <li>Apply the HELP framework in assessing behaviors of concern in hospitalized patients with IDD</li>\r\n    <li>Evaluate the effectiveness of interventions to reduce behaviors of concern in hospitalized patients with IDD</li>\r\n    <li>Differentiate interprofessional team contributions for effective treatment planning for the prevention and intervention for behaviors of concern</li>\r\n    <li>Describe pharmacological strategies for managing behaviors of concern and underlying mental health concerns that may be exacerbated in the context of hospital settings</li>\r\n    <li>Appraise the impact of diagnostic overshadowing as it applies to hospitalized patients with IDD when behaviors of concern are present</li>\r\n</ul>",
        "course_outline_html": "none provided",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "2E429D0C-4610-EE11-997D-005056A730AF",
                "course_category_name": "Golisano",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F0D93E9B-C313-F011-999F-005056A77B46",
                "course_category_name": "Golisano-CEUnlimited",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B756B56E-BDD2-EB11-80E3-005056B142B5",
                "course_category_name": "LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "552455CB-0469-E811-B6FF-005056B10E33",
                "course_category_name": "CE Unlimited featuring Challenge Tracks",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2F5C3339-BDD2-EB11-80E3-005056B142B5",
                "course_category_name": "Advance Practice Registered Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FEB7B714-954B-46A4-89D6-628F916FB59B",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B81F2B19-568D-4420-B695-B14EBFD6C36B",
                "course_category_name": "RN-BC: Gerontological",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0C0B7090-D960-F011-99A0-005056A740BF",
                "course_category_name": "Golisano - Optimizing Care for Hospitalized Individuals with Intellectual and Developmental Disabilities - Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53A09CBA-47F5-41DE-ABBC-397BDE607DA7",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5AC718D0-4CCE-4066-9398-56DBED0B6FC7",
                "course_category_name": "PMH-BC: Psych/Mental Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "162D7419-F1DE-4896-A447-ED5F2D41A1C1",
                "course_category_name": "CMSRN: Medical-Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BDB7B074-BDD2-EB11-80E3-005056B142B5",
                "course_category_name": "Registered Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B92FC0B9-AF4B-F011-99A4-005056A77B46",
                "course_category_name": "CE Unlimited_BRIDGE (No DEI Courses)",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "<em>The Golisano Institute for Developmental Disability Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Provider Number P0691</em>",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 1.0,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];